import AffiliationPage from '@/modules/affiliation/affiliation-page';
import { requireCapability } from '@/utils/route-guards';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_dashboard/dashboard/affiliation/')({
  beforeLoad: () => requireCapability('affiliation'),
  component: RouteComponent,
});

function RouteComponent() {
  return <AffiliationPage />;
}
